<template>
    <b-overlay :show="loading" rounded="sm">
    <b-card class="inner-block role-listing">
        <b-card-header>
            <b-row class="mt-2">
                <b-col cols="12" class="d-flex">
                    <b-input type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>
                    <b-button block variant="primary" v-if="hasPermissionCreate" @click="$emit('add-role')"><img
                            v-b-tooltip.hover :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body class="button-off">
            <b-col class="page-block">
                <strong>
                    {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} Total:
                    {{ pagination.total }}
                </strong>
            </b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <b-table id="roleTable" responsive :items="roles" :fields="fields">
                    <template #cell(id)="row">
                        <b-button-group size="sm">
                            <b-button v-if="hasPermissionView" @click="view(row.item.id)" class="mr-2"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </b-button-group>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                        :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                        :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                        align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

//import autoTable from 'jspdf-autotable'
export default {
    name: 'roles-table',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            query: '',
            page: 1,
            //template: false,
            loading: false,
        }
    },
    async mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        await this.doSearch()
    },

    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        async doSearch() {
            try {
                this.loading = true
                const {
                    pagination: { page = 1 },
                    query,
                } = this
                await this.$store.dispatch('roles/fetch', {
                    query,
                    page,
                })

            } catch (error) {
                console.error('loading error', error)
            } finally {
                this.loading = false
            }
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        activityRoleView(index) {
            const path = `activity-type-roles/${index}`
            this.$router.push({ path })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    watch: {
        'pagination.page': function (newPage) {
            if(this.page != newPage){
                this.changePage(newPage)
            }
            this.page = newPage
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    computed: {
        fields() {
            return [{ key: 'id', label: this.$translate('actions') }, { key: 'name', label: this.$nameLabel() }]
        },
        roles() {
            return this.$store.state.roles.items
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.roles.pagination || []
        },
        user() {
            return this.$store.state.user
        },
    },
}
</script>
<style></style>
